export const objectDiff = (o1, o2, exclude = []) =>
  Object.keys(o2).reduce((diff, key) => {
    if (exclude.includes(key)) return diff;
    return o1[key] === o2[key] ? diff : { ...diff, [key]: o2[key] };
  }, {});
